// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f97cd6c9","453":"ce3601f1"}[chunkId] + ".chunk.js";
};